import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import { intializeHotjar } from './hotjarSetup';

import App from './App';

intializeHotjar()
  .then(() => {
    ReactDOM.render(<App />, document.getElementById('root'));
  });

